import React from 'react'

const AboutApp = () => {
	return (
		<div className="rounded-2xl bg-[#eefffe] px-4 pb-24">
			<div className="container">
				<div className="mt-16 text-center md:mt-28">
					<h2 className="mb-4 text-3xl font-bold">
						Jak získáte více zákazníků?
					</h2>
					<p>Vytvoříme vám mobilní aplikaci s vlastní značkou.</p>
				</div>
				<div className="mt-10 grid grid-rows-4 text-center md:mx-20 md:grid-cols-2 md:grid-rows-2 md:text-left">
					<div className="flex items-center justify-center md:col-start-1 md:row-start-1">
						<div className="row-start-2 flex w-full max-w-[470px] flex-col justify-center gap-4  md:pl-20">
							<h3 className="text-3xl font-bold">Aplikace s vaší značkou</h3>
							<p>
								Vytvoříme vám unikátní mobilní aplikaci, kterou si vaší
								zákazníci budou moct stáhnout z AppStoru nebo Google Play. Díky
								ni budete se zákazníky blíž než kdy před tím.
							</p>
						</div>
					</div>
					<div className="row-start-1 flex items-center justify-center">
						<img src="img/eshops.webp" alt="iphone" width={503} height={250} />
					</div>
					<div className="row-start-3 flex items-center justify-center md:row-start-2">
						<img src="img/iphone1.webp" alt="iphone" width={503} height={250} />
					</div>
					<div className="flex justify-center">
						<div className="row-start-4 flex flex-col justify-center gap-4 md:row-start-2">
							<h3 className="text-3xl font-bold">Plánujte, organizujte</h3>
							<div className="space-y-6">
								<p className="max-w-[470px]">
									Díky vlastního administrátorského prostředí si můžete
									libovolně plánovat notifikace, stahovat data o uživatelích a
									mnoho dalšího.
								</p>
								{/* <div>
									<button className="rounded-[90px] bg-secondary px-10 py-4 text-white">
										Ukažte mi použité v praxi
									</button>
								</div> */}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default AboutApp
